import { render } from "./SystemLayout.vue?vue&type=template&id=3a2290c9"
import script from "./SystemLayout.vue?vue&type=script&lang=js"
export * from "./SystemLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__